import { useEffect, useRef, useState, type CSSProperties, type ReactNode, useId } from 'react';
import { img } from '../lib/bungie';

/** The pieces every Guardian page shares, in the app's look (GuardianHubPage's Card, Bar, ObjectiveStrip, ItemTile...). */

/** The app's own drawings for the left-side pages: line art on a 24 x 24 grid. */
/** The site's word that it is a fan project (shown on Maps and the sign-in page). */
export const BUNGIE_NOTE = 'D2 Companion is a fan-made site and is not affiliated with Bungie. Destiny 2 and its artwork are trademarks of Bungie, Inc.';

export const Draw = {
  Xur: 'M12,2.5 L20.5,7.5 V16.5 L12,21.5 L3.5,16.5 V7.5 Z M7,12 Q12,7 17,12 Q12,17 7,12 Z M10.5,12 a1.5,1.5 0 1,0 3,0 a1.5,1.5 0 1,0 -3,0',
  Target: 'M4,12 a8,8 0 1,0 16,0 a8,8 0 1,0 -16,0 M9,12 a3,3 0 1,0 6,0 a3,3 0 1,0 -6,0 M12,1.5 V5 M12,19 V22.5 M1.5,12 H5 M19,12 H22.5',
  SeasonCalendar: 'M4,6 H20 V20 H4 Z M4,10 H20 M8,3.5 V7.5 M16,3.5 V7.5 M12,12.5 L14.5,15 L12,17.5 L9.5,15 Z',
  Cycle: 'M19.5,9 A8,8 0 0,0 5,8 M5,4 V8 H9 M4.5,15 A8,8 0 0,0 19,16 M19,20 V16 H15',
  Trophy: 'M8,4 H16 V10 A4,4 0 0,1 8,10 Z M8,6 H5 A3,3 0 0,0 8,10 M16,6 H19 A3,3 0 0,1 16,10 M12,14 V18 M9.5,18 H14.5 M8.5,20.5 H15.5',
  Hourglass: 'M7,3.5 H17 M7,20.5 H17 M8,3.5 C8,9 16,15 16,20.5 M16,3.5 C16,9 8,15 8,20.5',
  Tree: 'M10,3.5 H14 V7.5 H10 Z M3.5,16.5 H7.5 V20.5 H3.5 Z M10,16.5 H14 V20.5 H10 Z M16.5,16.5 H20.5 V20.5 H16.5 Z M12,7.5 V16.5 M5.5,16.5 V12 H18.5 V16.5',
  Ranks: 'M5,11 L12,5 L19,11 M5,16 L12,10 L19,16 M5,21 L12,15 L19,21',
  ItemGrid: 'M4,4 H10.5 V10.5 H4 Z M13.5,4 H20 V10.5 H13.5 Z M4,13.5 H10.5 V20 H4 Z M13.5,13.5 H20 V20 H13.5 Z',
  Layers: 'M12,4 L20.5,8.5 L12,13 L3.5,8.5 Z M3.5,12.5 L12,17 L20.5,12.5 M3.5,16 L12,20.5 L20.5,16',
  Pillar: 'M5,4.5 H19 L17.5,7.5 H6.5 Z M8,7.5 V17 M12,7.5 V17 M16,7.5 V17 M6.5,17 H17.5 L19.5,20 H4.5 Z',
  ShieldPlus: 'M12,3 L19.5,6 V11.5 C19.5,16 16.5,19.5 12,21 C7.5,19.5 4.5,16 4.5,11.5 V6 Z M12,8.5 V15.5 M8.5,12 H15.5',
  Book: 'M12,6.5 C10,5 7,4.5 3.5,5 V18.5 C7,18 10,18.5 12,20 C14,18.5 17,18 20.5,18.5 V5 C17,4.5 14,5 12,6.5 Z M12,6.5 V20',
  Pattern: 'M12,3 L19.8,7.5 V16.5 L12,21 L4.2,16.5 V7.5 Z M12,8 L15.5,10 V14 L12,16 L8.5,14 V10 Z',
  Medal: 'M8,3 L12,10 L16,3 M7.5,15.5 a4.5,4.5 0 1,0 9,0 a4.5,4.5 0 1,0 -9,0 M12,13.3 L12.8,15 L14.6,15.2 L13.3,16.4 L13.6,18.2 L12,17.3 L10.4,18.2 L10.7,16.4 L9.4,15.2 L11.2,15 Z',
  Bars: 'M3.5,20.5 H21 M6.5,20 V13 M11,20 V8 M15.5,20 V11 M20,20 V4.5',
  Banner: 'M6,3 V21.5 M6,4.5 H19 V16 L15.75,13 L12.5,16 V4.5',
  People: 'M6,8 a3,3 0 1,0 6,0 a3,3 0 1,0 -6,0 M3.5,19.5 C3.5,15.5 6,13.5 9,13.5 C12,13.5 14.5,15.5 14.5,19.5 M16,5.5 a2.6,2.6 0 1,1 0,5.2 M17,13.5 C19.5,14 20.5,16 20.5,19.5',
  Crown: 'M4,17.5 L5.5,7.5 L9.5,12 L12,5.5 L14.5,12 L18.5,7.5 L20,17.5 Z M4.5,20.5 H19.5',
  Heart: 'M12,20 C6,15.5 3.5,12.5 3.5,9 A4.25,4.25 0 0,1 12,7.5 A4.25,4.25 0 0,1 20.5,9 C20.5,12.5 18,15.5 12,20 Z',
  Graph: 'M3.5,4 V20.5 H21 M6.5,16 L10.5,11 L14,14 L20,6.5',
  Engram: 'M12,2.5 L20.2,7.25 V16.75 L12,21.5 L3.8,16.75 V7.25 Z M12,2.5 L16.5,14.5 H7.5 Z M3.8,7.25 L7.5,14.5 L12,21.5 L16.5,14.5 L20.2,7.25',
  Helmet: 'M5,13 C5,7.5 8,4 12,4 C16,4 19,7.5 19,13 V19.5 H14.5 V15 H9.5 V19.5 H5 Z M5,11.5 H19',
  Backpack: 'M8,7 C8,5 9.5,3.5 12,3.5 C14.5,3.5 16,5 16,7 M5.5,7 H18.5 V20.5 H5.5 Z M5.5,11 H18.5 M9,14 H15 V17.5 H9 Z',
  VaultDoor: 'M3.5,4 H20.5 V20 H3.5 Z M8,12 a4,4 0 1,0 8,0 a4,4 0 1,0 -8,0 M12,8 V10 M12,14 V16 M8,12 H10 M14,12 H16 M6,20 V21.5 M18,20 V21.5',
  Stall: 'M4,9.5 L5.5,4 H18.5 L20,9.5 M4,9.5 a2.67,2.67 0 0,0 5.33,0 a2.67,2.67 0 0,0 5.33,0 a2.67,2.67 0 0,0 5.34,0 M5.5,12.5 V20.5 H18.5 V12.5 M10,20.5 V15.5 H14 V20.5',
  Checklist: 'M6,3.5 H18 V20.5 H6 Z M9,9 L11,11 L15,7 M9,14.5 H15 M9,17.5 H13',
  QuestMarker: 'M12,2.5 L19,12 L12,21.5 L5,12 Z M12,8 L15,12 L12,16 L9,12 Z',
  Compass: 'M3.5,12 a8.5,8.5 0 1,0 17,0 a8.5,8.5 0 1,0 -17,0 M15.5,8.5 L13.5,13.5 L8.5,15.5 L10.5,10.5 Z',
  Swords: 'M4,4 L14.5,14.5 M4,7 V4 H7 M12.5,17.5 L17.5,12.5 M15,15 L20,20 M20,4 L9.5,14.5 M20,7 V4 H17 M11.5,17.5 L6.5,12.5 M9,15 L4,20',
  Flame: 'M12,3 C13,7 17.5,9 17.5,14.5 A5.5,5.5 0 0,1 6.5,14.5 C6.5,12 8,10.5 9,9 C9.5,11 10.5,12 11.5,12 C11,9 11,6 12,3 Z',
  Ribbon: 'M7,3.5 H17 V20.5 L12,16.5 L7,20.5 Z',
  Cube: 'M12,2.5 L20.5,7.25 V16.75 L12,21.5 L3.5,16.75 V7.25 Z M3.5,7.25 L12,12 L20.5,7.25 M12,12 V21.5',
  Back: 'M19,12 H5 M11,6 L5,12 L11,18',
  Stopwatch: 'M5,13.5 a7,7 0 1,0 14,0 a7,7 0 1,0 -14,0 M12,13.5 V9.5 M10,3.5 H14 M12,3.5 V6.5 M18,7.5 L19.5,6',
  Planner: 'M9.5,5.5 a2.5,2.5 0 1,0 5,0 a2.5,2.5 0 1,0 -5,0 M12,8 V14 M8.5,11 H15.5 M12,14 L6,20.5 H18 Z',   // the app's Raid Planner figure on its stand
};

export function Art({ d, size = 24, stroke = 1.5, className, style }: { d: string; size?: number; stroke?: number; className?: string; style?: CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" className={className} style={style} aria-hidden="true">
      <path d={d} />
    </svg>
  );
}

/** A Bungie picture that fades in once it has arrived. */
export function Pic({ src, alt = '', className, style, width, height, lazy }: { src?: string; alt?: string; className?: string; style?: CSSProperties; width?: number; height?: number; lazy?: boolean }) {
  const [ok, setOk] = useState(false);
  const url = src ? (src.startsWith('http') ? src : img(src)) : undefined;
  if (!url) return <span className={className} style={{ ...style, width, height, display: 'block' }} />;
  return <img src={url} alt={alt} width={width} height={height} loading={lazy ? 'lazy' : 'eager'} decoding="async" className={(className ?? '') + (ok ? ' loaded' : ' loading')} style={style} onLoad={() => setOk(true)} onError={() => setOk(true)} />;
}

export const Card = ({ children, className = '', style, done }: { children: ReactNode; className?: string; style?: CSSProperties; done?: boolean }) => (
  <div className={`g-card ${done ? 'done' : ''} ${className}`} style={style}>{children}</div>
);

/** A progress bar whose fill grows from the left when it appears. White becomes the neon line. */
export function Bar({ fraction, color = '#ffffff', height = 4 }: { fraction: number; color?: string; height?: number }) {
  // white becomes the neon line; any other colour runs from a darker shade of itself (CSS variables work too)
  const neon = color.toLowerCase() === '#ffffff' || color.toLowerCase() === '#f2f3f7';
  return (
    <div className="g-bar" style={{ height, borderRadius: height / 2 }}>
      <div className="g-bar-fill" style={{ width: `${Math.max(0, Math.min(1, fraction)) * 100}%`, borderRadius: height / 2, background: neon ? 'var(--neon)' : `linear-gradient(90deg, color-mix(in srgb, ${color} 58%, black), ${color})` }} />
    </div>
  );
}

/** Bungie writes the game's little pictures as words in brackets ("[Fusion Rifle] final blows"): plain words instead. */
export const plain = (text: string) => text.replace(/\[([^\]]+)\]\s*(?=\1)/g, '').replace(/\[([^\]]+)\]/g, '$1');

/** One objective: a tick box, its words, a calm green wash for how far along, the count on the right. */
export function ObjectiveStrip({ text, progress, goal, done }: { text: string; progress: number; goal: number; done: boolean }) {
  const g = goal > 0 ? goal : 1;
  const part = done ? 1 : Math.max(0, Math.min(1, progress / g));
  return (
    <div className="g-obj">
      <div className={`g-obj-fill ${done ? 'done' : ''}`} style={{ width: `calc((100% - 24px) * ${part})` }} />
      <span className={`g-obj-box ${done ? 'done' : ''}`} />
      <span className="g-obj-text">{plain(text || 'Progress')}</span>
      <span className="g-obj-count">{progress.toLocaleString()}/{g.toLocaleString()}</span>
    </div>
  );
}

/** An item as a square: its icon, a number in the corner (power, or how many), what it is on hover. */
export function ItemTile({ icon, name, type, corner, more, size = 52, gold, dim, onClick, title }: {
  icon: string; name: string; type?: string; corner?: string; more?: string; size?: number; gold?: boolean; dim?: boolean; onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void; title?: string;
}) {
  const tip = title ?? [name, type, more].filter(Boolean).join('\n');
  return (
    <button className={`g-tile ${gold ? 'gold' : ''} ${onClick ? 'clickable' : ''}`} style={{ width: size, height: size }} title={tip} onClick={onClick} type="button">
      <Pic src={icon} style={dim ? { opacity: 0.4 } : undefined} lazy />
      {corner ? <span className={`g-tile-corner ${gold ? 'gold' : ''}`}>{corner}</span> : null}
    </button>
  );
}

/** A heading in spaced capitals, as the game writes them. */
export const Heading = ({ children, style }: { children: string; style?: CSSProperties }) => <div className="g-heading" style={style}>{children}</div>;

/** A section head: a title, a count on the right, and a hairline that fades out to the right. */
export function SectionHead({ title, count, warn, caps = false, size }: { title: string; count?: string; warn?: boolean; caps?: boolean; size?: number }) {
  return (
    <div className="g-section">
      <div className="g-section-row">
        <span className={caps ? 'caps' : ''} style={size ? { fontSize: size } : undefined}>{title}</span>
        {count !== undefined && <span className={`g-section-count ${warn ? 'warn' : ''}`}>{count}</span>}
      </div>
      <div className="g-rule" />
    </div>
  );
}

/** A heading written down the side of a column, as the game's own screens do. */
export const SideLabel = ({ text }: { text: string }) => <div className="g-sidelabel"><span>{text}</span></div>;

/** One line of a left-hand list: a name, a count on the right, an accent edge when chosen. */
export function ListRow({ name, count, selected, onClick }: { name: string; count?: string; selected?: boolean; onClick: () => void }) {
  return (
    <button className={`g-listrow ${selected ? 'on' : ''}`} onClick={onClick} type="button">
      <span className="name">{name}</span>
      {count !== undefined && <span className="count">{count}</span>}
    </button>
  );
}

/** The two-part page: title and list on the left (24 %), the content on the right. */
export const Split = ({ left, right }: { left: ReactNode; right: ReactNode }) => (
  <div className="g-split"><div className="g-split-left">{left}</div><div className="g-split-right">{right}</div></div>
);

/** "Asking Bungie..." with placeholder bars a light sweeps across. An error shows as plain text. */
/**
 * The waiting animation: Zag, the Ghost of the MrZagga app, drawn as the app draws him (tools\redesign\zag-mock.html
 * and Controls\ZagOrb in the app, on the same 46 x 46 grid): four faceted plates, each a lit and a shaded facet, round
 * a dark core with one eye. Here he is in his "fetching" mood, as when the app asks Bungie for something: the plates
 * open wide with a line of light along their inner edges, the shell spins the other way round, he bobs, his eye darts
 * from side to side, and now and then he blinks.
 */
export function Ghost({ size = 34 }: { size?: number }) {
  const id = useId().replace(/:/g, '');
  return (
    <svg className="g-ghost zag" viewBox="0 0 46 46" width={size} height={size} aria-hidden="true">
      <defs>
        <radialGradient id={`core${id}`} cx="35%" cy="30%" r="75%"><stop offset="0" stopColor="#2b2a30" /><stop offset="1" stopColor="#0e0d11" /></radialGradient>
        <clipPath id={`lid${id}`}><circle cx="23" cy="23" r="8.9" /></clipPath>
      </defs>
      <circle className="glow" cx="23" cy="23" r="15" />
      <g className="orb">
        <g className="shell">
          {[0, 90, 180, 270].map((a) => (
            <g key={a} className="plate" style={{ transform: `rotate(${a}deg)` }}>
              <g className="slide">
                <polygon className="lit" points="14,14.5 23,1.5 23,10.8" />
                <polygon className="shade" points="23,1.5 32,14.5 23,10.8" />
                <polyline className="seam" fill="none" points="14,14.5 23,10.8 32,14.5" />
              </g>
            </g>
          ))}
        </g>
        <circle className="core" cx="23" cy="23" r="9.5" fill={`url(#core${id})`} />
        <g className="eye">
          <circle className="rim" cx="23" cy="23" r="6.8" />
          <circle className="iris" cx="23" cy="23" r="4.6" />
          <circle className="pupil" cx="21.6" cy="21.5" r="1.5" />
        </g>
        <g clipPath={`url(#lid${id})`}><rect className="lidcover" x="12" y="-6.6" width="22" height="20" /></g>
      </g>
    </svg>
  );
}

export function Asking({ text }: { text: string }) {
  const waiting = /^(Asking|Loading|Reading|Building|Getting)/.test(text);
  if (!waiting) return <div className="g-asking"><p>{text}</p></div>;
  return (
    <div className="g-asking wait" role="status">
      <Ghost />
      <p className="g-sweeptext">{text}</p>
    </div>
  );
}

export function Message({ title, text, children }: { title: string; text: string; children?: ReactNode }) {
  // the first wait for the whole hub: the Ghost large in the middle of the page
  if (/^Loading/.test(title) && /^(Asking|Loading)/.test(text)) return (
    <div className="g-bigwait" role="status">
      <Ghost size={84} />
      <h2>{title}</h2>
      <p className="g-sweeptext">{text}</p>
      {children}
    </div>
  );
  return (
    <div className="g-message">
      <h2>{title}</h2>
      <Asking text={text} />
      {children}
    </div>
  );
}

export function Chip({ on, children, onClick }: { on?: boolean; children: ReactNode; onClick: () => void }) {
  return <button type="button" className={`g-chip ${on ? 'on' : ''}`} onClick={onClick}>{children}</button>;
}

export const SmallButton = ({ children, onClick, disabled, title }: { children: ReactNode; onClick?: () => void; disabled?: boolean; title?: string }) => (
  <button type="button" className="g-small" onClick={onClick} disabled={disabled} title={title}>{children}</button>
);

/** A whole number that counts up to its value when it appears. */
export function Counting({ value, format = (n: number) => n.toLocaleString() }: { value: number; format?: (n: number) => string }) {
  const [shown, setShown] = useState(value < 10 ? value : 0);
  const done = useRef(false);
  useEffect(() => {
    if (value < 10 || done.current) { setShown(value); return; }
    const start = performance.now();
    let raf = 0;
    const step = (t: number) => {
      const k = Math.min(1, (t - start) / 900);
      setShown(Math.floor(value * (1 - Math.pow(1 - k, 3))));
      if (k < 1) raf = requestAnimationFrame(step); else done.current = true;
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value]);
  return <>{format(shown)}</>;
}

/**
 * A row that is its own progress bar: an icon, a name and a count on a dark strip whose lighter part shows how far
 * along it is. tone: 'plain', 'chosen' (the open one), 'gold' (all done), 'earned' (a title held), 'dim'.
 */
export function FillRow({ icon, name, done, total, tone = 'plain', onClick }: { icon?: string; name: string; done: number; total: number; tone?: 'plain' | 'chosen' | 'gold' | 'earned' | 'dim'; onClick: () => void }) {
  const part = total > 0 ? Math.min(1, done / total) : 0;
  return (
    <button type="button" className={`g-fillrow ${tone} ${icon ? '' : 'noicon'}`} onClick={onClick}>
      <span className="g-fillrow-fill" style={{ width: `${part * 100}%` }} />
      <span className="g-fillrow-icon">{icon && <Pic src={icon} width={24} height={24} />}</span>
      <span className="g-fillrow-name">{name}</span>
      <span className="g-fillrow-count">{done} / {total}</span>
    </button>
  );
}

/** A side label with a column beside it (the game's "TRIUMPHS  391 / 1248" down the left of a list). */
export const Labelled = ({ label, count, children, style }: { label: string; count?: string; children: ReactNode; style?: CSSProperties }) => (
  <div className="g-labelled" style={style}>
    <SideLabel text={count ? `${label}      ${count}` : label} />
    <div className="g-labelled-body">{children}</div>
  </div>
);

export function Check({ label, hint, on, set }: { label: string; hint?: string; on: boolean; set: (v: boolean) => void }) {
  return (
    <label className="g-check">
      <input type="checkbox" checked={on} onChange={(e) => set(e.target.checked)} />
      <span>{label}</span>
      {hint && <small>{hint}</small>}
    </label>
  );
}

export const fmtDate =(d: Date, opts: Intl.DateTimeFormatOptions) => d.toLocaleDateString(undefined, opts);
